import { Route, Routes } from "react-router-dom";
import LocalesPage from "../../pages/module-pages/locales/LocalesPage";
import NewLocalePage from "../../pages/module-pages/locales/NewLocalePage";
import UpdateLocalePage from "../../pages/module-pages/locales/UpdateLocalePage";


export default function LocaleNav() {
  return (
    <Routes>
      <Route path="/" element={<LocalesPage />} />
      <Route path="/new" element={<NewLocalePage />} />
      <Route path="/update" element={<UpdateLocalePage />} />
    </Routes>
  );
}
